import type { AssetTimelineWrapperProps } from "./asset-timeline.type";

import { AssetTimeline } from "./asset-timeline.component";

export const AssetTimelineWrapper = ({
  assetId,
}: AssetTimelineWrapperProps) => {
  if (!assetId) return null;

  const id = parseInt(assetId, 10);

  return <AssetTimeline assetId={id} />;
};
